import { useMemo } from 'react';
import { useLang } from '../../../../../../hooks/use-lang';
import { useDashboardStore } from '../../../../../../store/use-dashboard-store';
import { ChartProps } from '../../dashboard-components/dashboard-charts/use-dashboard-charts';

interface DataType {
  overtime_percent: number;
  no_overtime_percent: number;
}

export const useWorkdayBalance = (): ChartProps => {
  const { t } = useLang();
  const { list } = useDashboardStore();
  const data = list?.deviation_balance as DataType;

  const chartData = useMemo<Partial<ChartProps>>(() => {
    if (data) {
      const series = [
        {
          name: t('Не перерабатывают'),
          data: [data.no_overtime_percent],
        },
        {
          name: t('Перерабатывают'),
          data: [data.overtime_percent],
        },
      ].filter((item) => !!item.data[0]);

      return {
        series,
        options: {
          chart: {
            type: 'bar',
            stacked: true,
            toolbar: { show: false },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              borderRadius: 12,
              columnWidth: '50%',
            },
          },
          grid: {
            show: false,
          },
          xaxis: {
            categories: [t('Баланс')],
            labels: { show: false },
            axisBorder: { show: false },
            axisTicks: { show: false },
          },
          yaxis: {
            labels: { show: false },
            axisBorder: { show: false },
            axisTicks: { show: false },
          },
          dataLabels: {
            enabled: true,
            formatter: (val) => `${val}%`,
            style: {
              colors: ['#fff'],
              fontSize: '16px',
            },
          },
          legend: {
            position: 'right',
            formatter: (label, opts) => {
              const value = opts.w.globals.series[opts.seriesIndex][0];
              return `${label} - ${value}%`;
            },
            fontSize: '14px',
            fontWeight: 400,
            inverseOrder: true,
            itemMargin: {
              horizontal: 8,
              vertical: 4,
            },
          },
          tooltip: {
            enabled: false,
          },
          colors: ['#19C37C', '#D80027'],
        },
      };
    }

    return {
      series: [],
      options: {},
    };
  }, [t, data]);

  return {
    label: 'Баланс отклонения от нормы рабочего дня',
    subLabel:
      'Дашборд отображает какой процент сотрудников перерабатывает или недорабатывает норму рабочего времени за выбранный период',
    type: 'bar',
    wrapped: true,
    series: chartData.series || [],
    options: chartData.options || {},
  };
};
